import { render, staticRenderFns } from "./DrawerFacts.vue?vue&type=template&id=08c6f103&scoped=true"
import script from "./DrawerFacts.vue?vue&type=script&lang=js"
export * from "./DrawerFacts.vue?vue&type=script&lang=js"
import style0 from "./DrawerFacts.vue?vue&type=style&index=0&id=08c6f103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c6f103",
  null
  
)

export default component.exports